var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.823 5.883a.942.942 0 0 1 0-1.883h4.236c.52 0 .941.422.941.941v4.236a.941.941 0 0 1-1.882 0V7.213l-5.453 5.452a.941.941 0 0 1-1.33-1.33l5.452-5.452h-1.964Zm3.295 7.058a.941.941 0 1 1 1.882 0v6.118c0 .52-.422.941-.941.941H4.94A.941.941 0 0 1 4 19.059V4.94c0-.52.422-.941.941-.941h6.118a.941.941 0 0 1 0 1.883H5.883v12.235h12.235V12.94Z",
    fill: "#000"
  })));
};
export default SvgExternalLink;